import { render, staticRenderFns } from "./BaiduLeadNotifier.vue?vue&type=template&id=6959d4bc&scoped=true"
import script from "./BaiduLeadNotifier.vue?vue&type=script&lang=js"
export * from "./BaiduLeadNotifier.vue?vue&type=script&lang=js"
import style0 from "./BaiduLeadNotifier.vue?vue&type=style&index=0&id=6959d4bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6959d4bc",
  null
  
)

export default component.exports